import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import * as yup from 'yup';
import { FavouriteBasketType } from '../../../models/favourite-basket-type';
import { FavouriteBasketsType } from '../../../models/favourite-baskets-type';
import FormText from '../../atoms/form-text/form-text';
import IcomoonIcon from '../../atoms/icomoon-icon/icomoon-icon';

interface Props extends FavouriteBasketsType {
  readonly baskets: FavouriteBasketType[];
  readonly onChange: (value: FavouriteBasketType) => void;
  readonly onSearch: (value: string | number) => void;
  readonly selectedBasket: FavouriteBasketType;
}

const FavouriteBasketsList: FC<Props> = ({
  baskets,
  onChange,
  onSearch,
  searchFavouritesBasketsFieldLabel,
  searchFavouritesBasketsFieldPlaceholderText,
  selectedBasket,
}: Props) => {
  const isSelected = (basket: FavouriteBasketType): boolean =>
    basket.id === selectedBasket?.id;

  const activeClass = (basket: FavouriteBasketType): string =>
    isSelected(basket) ? 'bg-french-blue text-white' : 'text-grey-600';

  return (
    <>
      <Formik
        initialValues={{
          searchTerm: '',
        }}
        validationSchema={yup.object({
          searchTerm: yup.string().label(searchFavouritesBasketsFieldLabel),
        })}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={null}
      >
        <Form className="mb-8 w-full">
          <FormText
            label={searchFavouritesBasketsFieldLabel}
            onChange={onSearch}
            name="searchTerm"
            placeholder={searchFavouritesBasketsFieldPlaceholderText}
            type="search"
          />
        </Form>
      </Formik>

      <nav>
        <ul>
          {baskets
            .sort((a: FavouriteBasketType, b: FavouriteBasketType) =>
              a.name.localeCompare(b.name)
            )
            .map((basket: FavouriteBasketType) => (
              <li key={basket.id} className="w-full">
                <button
                  className={
                    `${activeClass(basket)} ` +
                    'border-0 flex items-center justify-between focus:outline-none px-4 py-2 rounded-l-lg w-full'
                  }
                  onClick={() => onChange(basket)}
                  type="button"
                >
                  <span
                    className={`${
                      isSelected(basket) ? 'font-bold' : ''
                    } truncate`}
                  >
                    {basket.name}
                  </span>

                  {isSelected(basket) && (
                    <IcomoonIcon
                      color="white"
                      className="-mb-2px"
                      name="chevron-right"
                      size="sm"
                    />
                  )}
                </button>
              </li>
            ))}
        </ul>
      </nav>
    </>
  );
};

export default FavouriteBasketsList;
